import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import React, { useContext } from "react";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import "./FaxPageDrop.css";
const FaxPageDrop = (props) => {

    const { setDocumentData, data = {}, duplicateDocumentView, setDataSave } = useContext(DocumentDetailContext);

    const handleFaxRemoval = (event) => {
        let faxRemoval = {
          page_numbers: [1],
          enable : event.target.checked
        }
        data.Entity_Details.fax_cover_page_drop = faxRemoval;   
        setDocumentData({...data});
        setDataSave(true);
    }

    return <div className="cover-page-field">
        <FormGroup >
            <FormControlLabel
                name="fax-removal"
                control={
                    <Checkbox
                        size="small"
                        disabled={duplicateDocumentView || Object.hasOwn(data?.Entity_Details, "multi_page_drop")}
                        checked={data?.Entity_Details?.fax_cover_page_drop?.enable || false}
                        className="check-box-color"
                        onChange={handleFaxRemoval}
                    />
                }
                label={
                    <div style={{ textAlign: "left", marginLeft: "5px" }}>Remove Fax Cover Page</div>
                }
                labelPlacement="end"
            />
        </FormGroup>
    </div>
}

export default FaxPageDrop;